import * as THREE from "three";
import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField';
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
import { AddIcon } from './formUtil';
import {toast} from 'react-toastify';

import * as helptext from './helptext';

const FormAssemble = () => {
  const style       = SideStyle();
  const setParam    = Param.Get('setParam');
  const assembleAk  = Param.Get('assembleAk');
  const tsfd        = Control.Get('tsfd');
  const setControl  = Control.Get('setControl')

  useEffect(() => {
    if (tsfd==='ts') {
      toast('Please skip this "ASSEMBLE" phase for test socket.');
    } else if (tsfd==='fd') {
      toast('Adjust the alignment paramters.');
    }
  }, []);

  const handleValue = (e) => {
    setParam(s => {s.assembleAk[e.target.name] = Number(e.target.value)});
  };


  if (tsfd==='ts') {
    return (
      <div className={style.outside}>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='socketMl'
            label='Socket ML'
            type='number'
            defaultValue={assembleAk.socketMl}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkSocketMl; s.explanationImg = './static/ak/img/assembleAkSocketMl.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.assembleAkSocketMl}
              //   title='Socket ML'
              //   imgSrc='./static/ak/img/assembleAkSocketMl.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />

          <TextField
            id='filled-number'
            name='socketAp'
            label='Socket AP'
            type='number'
            defaultValue={assembleAk.socketAp}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkSocketAp; s.explanationImg = './static/ak/img/assembleAkSocketMl.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.assembleAkSocketAp}
              //   title='Socket AP'
              //   imgSrc='./static/ak/img/assembleAkSocketMl.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />
        </Grid>
      </div>
    );
  }


  if (tsfd==='fd') {
    return (
      <div className={style.outside}>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='socketMl'
            label='Socket ML'
            type='number'
            defaultValue={assembleAk.socketMl}
            fullWidth
            onChange={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='mm' helptext='Socket ML shift value.'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />

          <TextField
            id='filled-number'
            name='socketAp'
            label='Socket AP'
            type='number'
            defaultValue={assembleAk.socketMl}
            fullWidth
            onChange={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='mm' helptext='Socket AP shift value.'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />

          <TextField
            id='filled-number'
            name='socketSi'
            label='Socket SI'
            type='number'
            defaultValue={assembleAk.socketSI}
            fullWidth
            onChange={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='mm' helptext='Socket SI shift value.'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-200, 
              max:200,
              step:1
            }}
          />
        </Grid>
      </div>
    );
  }
}
export default FormAssemble;
